import {connect} from 'react-redux';

import {changeResolution} from '../../actionCreators';

const ResolutionItem = ({label, onClick}) => (
    <li onClick={onClick}>{label}</li>
);

const mapDispatchToProps = (dispatch, {value}) => ({
    onClick: () => dispatch(changeResolution(value)),
});

export default connect(undefined, mapDispatchToProps)(ResolutionItem);
